import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { toast } from "sonner";

// Stagione di riferimento delle vendite, condivisa da Vendite e Panoramica
export const useSalesSeason = () => {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["sales-season"], queryFn: async () => (await api.get("/settings/sales-season")).data, staleTime: 60000 });
  const save = useMutation({
    mutationFn: async (season) => (await api.put("/settings/sales-season", { season })).data,
    onSuccess: (d) => {
      qc.setQueryData(["sales-season"], d);
      qc.invalidateQueries({ queryKey: ["overview"] });
      qc.invalidateQueries({ queryKey: ["customers"] });
      qc.invalidateQueries({ queryKey: ["customer"] });
      toast.success(`Stagione di riferimento: ${d.season}`);
    },
    onError: (e) => toast.error(e.response?.data?.detail || "Stagione non salvata"),
  });
  return { season: data?.season, setSeason: (s) => save.mutate(s), saving: save.isPending };
};
